<template>
  <el-container>
    <el-main style="padding: 0; display: flex">
      <div style="width: 550px">
        <span>生产报修</span>
        <el-form
            ref="form"
            v-loading="contentLoading"
            style="width: 550px"
            :rules="ruleValidate"
            :model="model"
            class="form"
            label-width="90px"
            @submit.native.prevent>
          <el-form-item label="序列号">
            <el-input
                ref="materialSnInput"
                v-model="model.barcode"
                placeholder="请扫描序列号"
                size="mini"
                @keyup.enter.native="getProcess"/>
          </el-form-item>
          <el-form-item label="工单号">
            <el-input v-model="model.productionNo"/>
          </el-form-item>
          <el-form-item label="物料号" prop="materialNo">
            <el-input v-model="model.materialNo" disabled placeholder="请选物料">
              <el-button slot="append" @click="$refs.materialSelect.open()"> 选择</el-button>
            </el-input>
            <material-select ref="materialSelect" @select="materialSelect"/>
          </el-form-item>
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="model.materialName"/>
          </el-form-item>
          <el-form-item label="工序" prop="processName">
            <el-input v-model="model.processName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="工位" prop="station">
            <el-input v-model="model.station" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="问题描述" prop="faultReporting">
            <el-select
                v-model="model.faultReporting"
                allow-create
                clearable
                filterable
                placeholder="如有其他，请手动输入！">
              <el-option
                  v-for="item in constants.faultReporting.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button type="primary" :loading="submitLoading" @click="saveMaintenance">报修-工单条码</el-button>
          <el-button type="danger" style="margin-left: 80%" :loading="submitLoading" @click="saveMaintenance2">报修-异常条码</el-button>
        </span>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import constants from "@/util/constants";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    components: {MaterialSelect},

    data() {
      return {
        constants,
        contentLoading: false,
        submitLoading: false,
        complete: false,
        lastProcessId: "",
        lastRouteId: "",
        esopFile: "",
        esopPageNo: 1,
        productionType: "",
        bindVehicleType: "",
        processList: [],
        model: {
          barcode: "",
          productionNo: "",
          processNo: "",
          materialNo: "",
          materialName: "",
          specification: "",
          faultReporting: "",
          processName: "",
          station: "",
        },
        ruleValidate: {},
      };
    },

    methods: {
      getProcess() {
        console.log(this.model.barcode);
        if (this.model.barcode) {
          let barcode = this.model.barcode;
          if (barcode.includes("_")) {
            this.model.barcode = barcode.split("_")[1];
          }
          this.contentLoading = true;
          let params = {
            sn: this.model.barcode,
          };
          this.$http.get("basic", "snSerialNos/getVoBySn", params).then((res) => {
            this.model.barcode = res.data.serialNo;
            this.model.productionNo = res.data.refBillNo;
            this.model.materialNo = res.data.materialNo;
            this.model.specification = res.data.specification;
            this.model.processName = res.data.procedureName;
            this.model.materialName = res.data.materialDescription;
            this.contentLoading = false;
          }).catch(() => {
            this.contentLoading = false;
          });
        }

      },
      materialSelect(row) {
        this.model.materialId = row.id;
        this.model.materialName = row.name;
        this.model.materialNo = row.no;
        this.model.specification = row.specification;
      },
      saveMaintenance() {
        this.submitLoading = true;
        console.log(this.model);
        this.$http.post("basic", "repairRegistrations/bx", this.model).then(() => {
          this.submitLoading = false;
          this.$message.success("报修成功");
          this.resetOtherData();
        }).catch(() => {
          this.submitLoading = false;
        });
      },
      saveMaintenance2() {
        this.submitLoading = true;
        console.log(this.model);
        this.$http.post("basic", "repairRegistrations/ycbx", this.model).then(() => {
          this.submitLoading = false;
          this.$message.success("报修成功");
          this.resetOtherData();
        }).catch(() => {
          this.submitLoading = false;
        });
      },
      resetFiled(data) {
        data.forEach((item) => {
          let result = this.$refs.form.fields.find((f) => f.prop === item);
          if (result) {
            result.resetField();
          }
        });
      },
      resetOtherData() {
        this.complete = false;
        this.model.barcode = "";
        this.model.productionNo = "";
        this.model.materialNo = "";
        this.model.processName = "";
        this.model.materialName = "";
        this.model.faultReporting = "";
        this.model.station = "";
      },
    },
  };
</script>
